import(/* webpackMode: "eager", webpackExports: ["BuyPackageHeader"] */ "/codebuild/output/src2540224303/src/app/src/v2/components/BuyPackageHeader/BuyPackageHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageLoader"] */ "/codebuild/output/src2540224303/src/app/src/v2/components/PageLoader/PageLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuyPackageContent"] */ "/codebuild/output/src2540224303/src/app/src/v2/views/buy/BuyPackage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventEndedDialog"] */ "/codebuild/output/src2540224303/src/app/src/v2/views/buy/components/EventEndedDialog.tsx");
